import CourseCard from './CourseCard';
import { JoinByType } from '../models/UserGroup';
import PayPalService from '../../shared/services/PayPalService';
import React from 'react';
import UserGroupVm from '../models/UserGroupVm';

interface CourseGroupCardProps {
  group: UserGroupVm;
  currency: string;
  onJoin: (
    groupkey: number,
    groupName: string,
    price: number,
    purchased: boolean
  ) => void;
  onJoinByCode: (groupkey: number, code: string) => void;
}

/** Group join by options */
const joinByOptions: { [key in JoinByType]: { label: string; tag: string } } = {
  free: { label: 'Enroll', tag: 'Free' },
  paid: { label: 'Purchase', tag: '' },
  code: { label: '', tag: 'Access Code' }
};

const CourseGroupCard = (props: CourseGroupCardProps) => {
  const { group } = props;

  const handleJoin = () => {
    const { groupkey, title, assets, purchased } = group;
    props.onJoin(groupkey, title, assets?.amount, purchased);
  };

  const handleJoinByCode = (code: string) => {
    props.onJoinByCode(group.groupkey, code);
  };

  // Define group join by option.
  const groupJoinBy: JoinByType = group.assets?.amount
    ? 'paid'
    : group?.assets?.code
    ? 'code'
    : 'free';

  // Update tag if it is `paid` group.
  if (groupJoinBy === 'paid') {
    joinByOptions['paid'].tag = PayPalService.formatPrice(
      group.assets.amount,
      props.currency
    );
  }

  return (
    <CourseCard
      title={group.title}
      description={group.assets?.description}
      assetkey={group.assets?.media}
      code={group.assets?.code}
      priceTag={joinByOptions[groupJoinBy].tag}
      groupJoinBy={joinByOptions[groupJoinBy].label}
      joined={group.joined}
      onJoin={handleJoin}
      onJoinByCode={handleJoinByCode}
    />
  );
};

export default CourseGroupCard;
